import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const RotateRightCheck = ({
  size = 24,
  color = Colors.black,
  className,
}: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8929 15.8939C12.6385 19.1482 7.36214 19.1482 4.10777 15.8939C0.8534 12.6395 0.8534 7.36312 4.10777 4.10875C7.36214 0.854376 12.6385 0.854376 15.8929 4.10875M16.667 1.66797V4.91797C16.667 4.96399 16.6297 5.0013 16.5837 5.0013H13.3337M13.3337 8.33464L9.0306 12.2465C8.87168 12.391 8.62897 12.391 8.47004 12.2465L6.66699 10.6074"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.6"
      />
    </svg>
  </SvgIcon>
);
